
































import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { Newsletter } from './Footer';
/**
 * `Newsletter Footer` - Newsletter for OneWeb - Newsletter Footer contains a button link which redirects the user to a given url, mostly to a newsletter signup form.
 */

export default ComponentInitializeDispatcher.extend({
  name: 'owc-newsletter',
  props: {
    datajson: {
      type: String,
      required: true,
    },
  },
  computed: {
    json: function(): Newsletter {
      return JSON.parse(this.datajson);
    },
    titleLabel: function(): string {
      return this.json.titleLabel;
    },
    submitLabel: function(): string {
      return this.json.submitLabel;
    },
    descriptionLabel: function(): string {
      return this.json.descriptionLabel;
    },
    actionURL: function(): string {
      return this.json.actionURL;
    },
  },
  methods: {
    customTrackingTrigger() {
      this.handleCustomTracking(this.$el, 'newsletter', 'feature', 'click');
    },
  },
});
